// src/pages/Users/Galleries/components/AlbumDetailSkeleton.jsx

import React from "react";

export default function AlbumDetailSkeleton() {
  return (
    <div className="space-y-5">
      <div className="rounded-[2rem] bg-slate-200 p-5 dark:bg-slate-800">
        <div className="h-8 w-40 animate-pulse rounded-full bg-slate-300 dark:bg-slate-700" />
        <div className="mt-5 h-10 w-3/4 animate-pulse rounded-full bg-slate-300 dark:bg-slate-700" />
        <div className="mt-3 h-4 w-full animate-pulse rounded-full bg-slate-300 dark:bg-slate-700" />
        <div className="mt-2 h-4 w-2/3 animate-pulse rounded-full bg-slate-300 dark:bg-slate-700" />

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-20 animate-pulse rounded-2xl bg-slate-300 dark:bg-slate-700"
            />
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="aspect-[4/3] animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-slate-800"
          />
        ))}
      </div>
    </div>
  );
}